export default __webpack_public_path__ + "static/page7Vp1-0d3b256822d4be08cb03eacf6cbd045c.png";